import * as types from '../constants/actionTypes';

export const fetchVendors = () => ({
  type: types.FETCH_VENDORS_REQUEST
});

export const fetchVendorsSuccess = (vendors) => ({
  type: types.FETCH_VENDORS_SUCCESS,
  payload: vendors
});

export const fetchVendorsFailure = (error) => ({
  type: types.FETCH_VENDORS_FAILURE,
  payload: error
});

export const createVendor = (vendorData) => ({
  type: types.CREATE_VENDOR_REQUEST,
  payload: vendorData
});

export const createVendorSuccess = (vendor) => ({
  type: types.CREATE_VENDOR_SUCCESS,
  payload: vendor
});

export const createVendorFailure = (error) => ({
  type: types.CREATE_VENDOR_FAILURE,
  payload: error
});

export const updateVendor = (id, vendorData) => ({
  type: types.UPDATE_VENDOR_REQUEST,
  payload: { id, vendorData }
});

export const updateVendorSuccess = (vendor) => ({
  type: types.UPDATE_VENDOR_SUCCESS,
  payload: vendor
});

export const updateVendorFailure = (error) => ({
  type: types.UPDATE_VENDOR_FAILURE,
  payload: error
});

export const fetchVendor = (id) => ({
  type: types.FETCH_VENDOR_REQUEST,
  payload: id
});

export const fetchVendorSuccess = (vendor) => ({
  type: types.FETCH_VENDOR_SUCCESS,
  payload: vendor
});

export const fetchVendorFailure = (error) => ({
  type: types.FETCH_VENDOR_FAILURE,
  payload: error
});
